(() => {
  "use strict";

  if (window.__rudixLengthFilterV4) return;
  window.__rudixLengthFilterV4 = true;

  const ROOT = ".product-single__meta .globo-swatch-product-detail";
  const AUTO_SELECT_INITIAL_VARIANT = true;
  const hiddenAttribute = "data-rudix-length-hidden";
  const savedDisabled = new WeakMap();
  const collator = new Intl.Collator(undefined, { numeric: true });
  let state;
  let timer;

  const option = (variant, index) =>
    String(variant.options?.[index] ?? variant[`option${index + 1}`] ?? "");

  const compare = (a, b) => {
    const left = Number.parseFloat(a);
    const right = Number.parseFloat(b);
    return Number.isFinite(left) && Number.isFinite(right)
      ? left - right || collator.compare(a, b)
      : collator.compare(a, b);
  };

  const schedule = () => {
    if (timer !== undefined) return;
    timer = window.setTimeout(() => {
      timer = undefined;
      refresh();
    }, 0);
  };

  const observer = new MutationObserver(schedule);

  const selectThroughGlobo = (input) => {
    if (input && !input.checked && !input.disabled) input.click();
  };

  function refresh() {
    const config = window.GloboSwatchConfig;
    const product = config?.product;
    const names = product?.options?.map((item) =>
      typeof item === "string" ? item : item.name
    );
    if (!names || names.length !== 2 || !product.variants?.length) return;
    if (product.variants.length >= 250) return;

    const metalIndex = names.findIndex((name) => /^metal(?: type)?$/i.test(name));
    const lengthIndex = names.findIndex((name) => /^length$/i.test(name));
    if (metalIndex < 0 || lengthIndex < 0) return;

    const root = document.querySelector(ROOT);
    if (!root) return;
    const metalGroup = root.querySelector(`[data-option-index="${metalIndex}"]`);
    const lengthGroup = root.querySelector(`[data-option-index="${lengthIndex}"]`);
    const list = lengthGroup?.querySelector("ul.ul-globo-dropdown-option");
    if (!metalGroup || !list) return;

    if (!state || state.root !== root || state.productId !== product.id) {
      const requestedId = new URL(location.href).searchParams.get("variant");
      const seed = product.variants.find((v) => String(v.id) === requestedId) ||
        product.variants.find((v) => String(v.id) === String(config.curVariant?.id)) ||
        product.variants.find((v) => v.available) || product.variants[0];
      state = { root, productId: product.id, seed };
    }

    observer.disconnect();
    try {
      if (!document.getElementById("rudix-globo-length-filter-style")) {
        const style = document.createElement("style");
        style.id = "rudix-globo-length-filter-style";
        style.textContent = `${ROOT} [${hiddenAttribute}] { display: none !important; }`;
        document.head.append(style);
      }

      const metalInputs = [...metalGroup.querySelectorAll('input[type="radio"]')];
      const selectedMetal = metalInputs.find((input) => input.checked);
      if (!selectedMetal) {
        if (AUTO_SELECT_INITIAL_VARIANT) {
          selectThroughGlobo(metalInputs.find((input) =>
            input.value === option(state.seed, metalIndex)
          ));
        }
        return;
      }

      const allowed = new Set(product.variants
        .filter((variant) => option(variant, metalIndex) === selectedMetal.value)
        .map((variant) => option(variant, lengthIndex)));

      const rows = [...list.children]
        .filter((row) => row.matches("li.select-option--dropdown"))
        .map((row) => ({ row, input: row.querySelector('input[type="radio"]') }))
        .filter(({ input }) => input);

      for (const { row, input } of rows) {
        const invalid = !allowed.has(input.value);
        row.toggleAttribute(hiddenAttribute, invalid);
        if (invalid) {
          if (!savedDisabled.has(input)) savedDisabled.set(input, input.disabled);
          input.disabled = true;
        } else if (savedDisabled.has(input)) {
          input.disabled = savedDisabled.get(input);
          savedDisabled.delete(input);
        }
      }

      rows.sort((a, b) => compare(a.input.value, b.input.value));
      rows.forEach(({ row }, index) => {
        if (list.children[index] !== row) {
          list.insertBefore(row, list.children[index] || null);
        }
      });

      const current = rows.find(({ input }) => input.checked);
      if (current && allowed.has(current.input.value)) return;
      if (!current && !AUTO_SELECT_INITIAL_VARIANT) return;

      const seededLength = !current &&
        selectedMetal.value === option(state.seed, metalIndex)
        ? option(state.seed, lengthIndex) : null;
      const usable = rows.filter(({ input }) => allowed.has(input.value) && !input.disabled);
      const next = usable.find(({ input }) => input.value === seededLength) || usable[0];
      selectThroughGlobo(next?.input);
    } finally {
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  window.addEventListener("Globo.swatch.inited", schedule);
  window.addEventListener("Globo.swatch.loaded", schedule);
  window.addEventListener("globoSwatchClickedVariantSwatch", schedule);
  document.addEventListener("variant:change", schedule);
  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("click", (event) => {
    if (event.target instanceof Element &&
      event.target.closest(`${ROOT} .dropdown-button-gsw`)) schedule();
  }, true);

  window.RudixGloboLength = { refresh: schedule };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }
})();